import { defineComponentStyle } from "@/components/ui"

export const stackStyle = defineComponentStyle({
  base: {
    display: "flex",
    gap: "{space}",
  },
})

export type StackStyle = typeof stackStyle
